<template>
  <hr class="block h-[1px] border-0 border-t border-solid border-ryd-gray3 opacity-50 my-1 mx-0 p-0" />
</template>
<script>
export default {};
</script>
<style lang="scss" scoped></style>
